import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box, CssBaseline, CircularProgress } from '@mui/material';
import axios from 'axios';

const VerifyOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const secret = location.state?.secret || '';
  const email = location.state?.email || '';

  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    try {
      const body = {
        email: email,
        otp: otp,
        secret: secret
      };
      //console.log(secret)
      const apiUrl2 = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl2}/api/user/verify-otp`, body, {
        headers: {
        'Authorization': getBasicAuthHeader(),
        },
      });
      //console.log(response)
      if (response.status === 200) {
        const resetToken = response.data.resetToken;
        navigate('/new-password', { state: { resetToken, email } });
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      navigate('/error', { state: { message: 'Wrong One Time Password.' } });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm" style={{ height: '52vh', display: 'flex', alignItems: 'center' }}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography component="h1" variant="h5">
          Verify One Time Password
        </Typography>
        <Box component="form" onSubmit={(e) => { e.preventDefault(); handleVerifyOtp(); }} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="otp"
            label="One Time Password"
            name="otp"
            autoComplete="otp"
            autoFocus
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            inputProps={{ maxLength: 6, pattern: '[0-9]*' }}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleVerifyOtp}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default VerifyOtp;
